import { createContext, useContext } from 'react';

/** Opens Send feedback; `returnFocusTo` is the control that opened it (focus goes back there). */
export type OpenFeedback = (returnFocusTo: HTMLElement | null) => void;

const FeedbackOpenerContext = createContext<OpenFeedback | null>(null);

/** Provided by the shell around the page: the same Send feedback the header button opens. */
export const FeedbackOpenerProvider = FeedbackOpenerContext.Provider;

/**
 * A page's own way into Send feedback (APP-138: My feedback's "Send feedback"), or null when
 * feedback isn't on for this person, so the page leaves the button out rather than greying it.
 */
export function useOpenFeedback(): OpenFeedback | null {
  return useContext(FeedbackOpenerContext);
}
